import { Core } from "@faire/design-tokens";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import privacyPath from "@faire/web-api/routes/privacy";
import tosPath from "@faire/web-api/routes/tos";
import tosBrandPath from "@faire/web-api/routes/tos-brand";
import Checkbox from "@faire/web/slate/Checkbox";
import { Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { type JSX } from "react";
import styled from "styled-components";

interface CheckboxProps {
  hasError: boolean;
  value: boolean;
  onChange: () => void;
  brandCountrySelected?: keyof typeof ISO3166Alpha3 | "Other" | "";
}
export const AcceptTermsCheckbox: React.FC<CheckboxProps> = ({
  hasError,
  value,
  onChange,
}) => (
  <Row>
    <Checkbox
      data-test-id="accept-terms-checkbox"
      margin="2px 8px 0 0"
      align="flex-start"
      checked={value}
      borderColor={hasError ? Core.border.critical : undefined}
      onChange={onChange}
    >
      <Typography color={hasError ? Core.text.critical : Core.text.default}>
        <StrictLocalMsg
          defaultMessage="By proceeding, you're agreeing to our <TosLinkFormatting>Terms of Service</TosLinkFormatting>, <BrandLinkFormatting>Brand Agreement</BrandLinkFormatting>, and <PrivacyLinkFormatting>Privacy Policy</PrivacyLinkFormatting>."
          values={{
            TosLinkFormatting,
            BrandLinkFormatting,
            PrivacyLinkFormatting,
          }}
          description={{
            text: "Label for the checkbox users check to agree to faire's Terms of Service",
          }}
        />
      </Typography>
    </Checkbox>
  </Row>
);

const StyledLink = styled(EmbeddedLink).attrs({
  target: "_blank",
})`
  color: inherit;
  text-decoration-color: inherit;
`;

const TosLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={tosPath()}>{chunks}</StyledLink>
);
const BrandLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={tosBrandPath()}>{chunks}</StyledLink>
);
const PrivacyLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={privacyPath()}>{chunks}</StyledLink>
);
